import { render, staticRenderFns } from "./Empresas.vue?vue&type=template&id=3534893e&scoped=true&"
import script from "./Empresas.vue?vue&type=script&lang=js&"
export * from "./Empresas.vue?vue&type=script&lang=js&"
import style0 from "./Empresas.vue?vue&type=style&index=0&id=3534893e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3534893e",
  null
  
)

export default component.exports